<template>
  <div class="wrapper" v-if="data != undefined">
    <Menu />

    <div class="header-area">
      <div class="container-fluid">
        <div class="position-relative row player-career">
          <div class="header-area position-absolute w-100 bg-transparent border-0 fc-5">
            <div class="container-fluid">
              <div class="row">
                <div class="col-6">
                  <a @click="$router.go(-1)" href="javascript:;">
                    <span class="back-arrow mt-4"></span>
                  </a>
                </div>
                <div class="col-6 text-right">
                  <a
                    href="javascript:;"
                    @click="$openShare('https://anadoluefessk.org/takim/oyuncu/' + data.slug, data.name + ' Oyuncu İstatistikleri')"
                  >
                    <span class="menu-dot mt-4"></span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 mt-5">
            <h1 class="fs-32 fc-5 position-absolute font-weight-normal">
              <span class="fs-64">{{data.jerseyNo}}</span>
              <br />
              <span v-html="data.name.replace(' ', '<br>')"></span>
            </h1>
            <figure class="float-right">
              <div
                :style="'background-image: url(' + data.images.body + '); height: 50vh; width: 100%; background-size: auto 100%;    background-position: 0 -70px;    background-repeat: no-repeat;    background-position-x: center;'"
              ></div>
            </figure>
          </div>
        </div>
      </div>
    </div>
    <div class="body-area">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 p-0">
            <div class="tab-box">
              <div class="tab-header text-center bb-1">
                <div class="row no-gutters">
                  <div
                    class="col-6 tab-select"
                    :class="tab == 'career' ? 'active' : ''"
                    @click="changeTab('career')"
                  >
                    <h1 class="fs-16">Kariyeri</h1>
                  </div>
                  <div
                    class="col-6 tab-select"
                    :class="tab == 'statistics' ? 'active' : ''"
                    @click="changeTab('statistics')"
                  >
                    <h1 class="fs-16">İstatistikleri</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- BEGIN CAREER -->
          <div class="col-12" v-if="tab == 'career'">
            <div class="row py-3 player-block" style="margin-bottom: 0">
              <div class="position">
                <span class="fs-15 fc-2 font-weight-bold">Pozisyon</span>
                <span class="fs-18 fc-1">{{data.position}}</span>
              </div>
              <div class="age">
                <span class="fs-15 fc-2 font-weight-bold">Yaş</span>
                <span
                  class="fs-18 fc-1"
                >{{moment().diff(data.unformattedBirthDate, 'years', false)}}</span>
              </div>
              <div class="long">
                <span class="fs-15 fc-2 font-weight-bold">Boy</span>
                <span class="fs-18 fc-1">{{data.height}}</span>
              </div>
              <div class="nation">
                <span class="fs-15 fc-2 font-weight-bold">Doğum Yeri</span>
                <span class="fs-18 fc-1">{{data.birthPlace}}</span>
              </div>
            </div>
          </div>
          <div class="col-12 p-0" v-if="tab == 'career'">
            <div class="item-box p-3" style="margin-top: 0">
              <div class="content-block" v-html="data.description"></div>
            </div>
          </div>
          <!-- END CAREER -->

          <!-- BEGIN STATISTICS -->

          <div class="col-12 p-0" v-if="tab == 'statistics'">
            <div class="item-box p-g">
              <div class="box-header bb-1 px-0">
                <h1 class="fs-18 fc-6 font-weight-normal">{{getStats[index].tournamentName}}</h1>
                <div class="slider-dots text-center float-right statistics">
                  <span v-for="(item, i) in getStats" :key="i" :class="index == i ? 'active' : ''"></span>
                </div>
              </div>

              <carousel :perPage="1" @pageChange="pageChanged">
                <slide v-for="(item, index) in getStats" :key="index">
                  <div class="box-body px-0">
                    <div class="row bb-1 py-3 no-gutters">
                      <div class="col-4 text-center">
                        <span class="fs-11 fc-2 font-weight-bold d-block">Toplam Maç</span>
                        <span class="fs-32 fc-1 rbs d-block">{{item.playedMatchCount}}</span>
                      </div>
                      <div class="col-4 text-center">
                        <span class="fs-11 fc-2 font-weight-bold d-block">Ortalama Süre</span>
                        <span class="fs-32 fc-1 rbs d-block">{{item.minutesPerGame}}</span>
                      </div>
                      <div class="col-4 text-center">
                        <span class="fs-11 fc-2 font-weight-bold d-block">Maç Başına Sayı</span>
                        <span class="fs-32 fc-1 rbs d-block">{{item.pointsPerGame}}</span>
                      </div>
                    </div>

                    <div class="row no-gutters mt-2">
                      <div class="col-4 br-1 my-2 text-center">
                        <span class="fs-11 fc-2 d-block">Serbest Atış</span>
                        <span class="fs-32 fc-1 rbs d-block">%{{item.freeThrow}}</span>
                      </div>

                      <div class="col-4 br-1 my-2 text-center">
                        <span class="fs-11 fc-2 d-block">2 Sayı</span>
                        <span class="fs-32 fc-1 rbs d-block">%{{item.twoPoints}}</span>
                      </div>

                      <div class="col-4 my-2 text-center">
                        <span class="fs-11 fc-2 d-block">3 Sayı</span>
                        <span class="fs-32 fc-1 rbs d-block">%{{item.threePoints}}</span>
                      </div>

                      <div class="col-4 br-1 my-2 text-center">
                        <span class="fs-11 fc-2 d-block">Ribaunt</span>
                        <span class="fs-32 fc-1 rbs d-block">{{item.rebounds}}</span>
                      </div>

                      <div class="col-4 br-1 my-2 text-center">
                        <span class="fs-11 fc-2 d-block">S. Ribaunt</span>
                        <span class="fs-32 fc-1 rbs d-block">{{item.defensiveRebounds}}</span>
                      </div>

                      <div class="col-4 my-2 text-center">
                        <span class="fs-11 fc-2 d-block">H. Ribaunt</span>
                        <span class="fs-32 fc-1 rbs d-block">{{item.offensiveRebounds}}</span>
                      </div>

                      <div class="col-4 br-1 my-2 text-center">
                        <span class="fs-11 fc-2 d-block">Asist</span>
                        <span class="fs-32 fc-1 rbs d-block">{{item.assist}}</span>
                      </div>

                      <div class="col-4 br-1 my-2 text-center">
                        <span class="fs-11 fc-2 d-block">Top Çalma</span>
                        <span class="fs-32 fc-1 rbs d-block">{{item.steals}}</span>
                      </div>

                      <div class="col-4 my-2 text-center">
                        <span class="fs-11 fc-2 d-block">Top Kaybı</span>
                        <span class="fs-32 fc-1 rbs d-block">{{item.turnovers}}</span>
                      </div>

                      <div class="col-4 br-1 my-2 text-center">
                        <span class="fs-11 fc-2 d-block">Faul</span>
                        <span class="fs-32 fc-1 rbs d-block">{{item.fouls}}</span>
                      </div>

                      <div class="col-4 br-1 my-2 text-center">
                        <span class="fs-11 fc-2 d-block">Blok</span>
                        <span class="fs-32 fc-1 rbs d-block">{{item.blocks}}</span>
                      </div>

                      <div class="col-4 br-1 my-2 text-center">
                        <span class="fs-11 fc-2 d-block">Yapılan Faul</span>
                        <span class="fs-32 fc-1 rbs d-block">{{item.foulsReceived}}</span>
                      </div>

                      <div class="col-4 br-1 my-2 text-center">
                        <span class="fs-11 fc-2 d-block">Verimlilik Puanı</span>
                        <span class="fs-32 fc-1 rbs d-block">{{item.effPoints}}</span>
                      </div>
                    </div>
                  </div>
                </slide>
              </carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Menu from "@/components/Menu";
import axios from "axios";
import moment from "moment";

export default {
  name: "Player",
  components: {
    Footer,
    Menu,
    Header
  },
  data() {
    return {
      tab: "career",
      slug: this.$route.params.slug,
      data: this.$route.params.data,
      moment,
      index: 0
    };
  },
  methods: {
    changeTab(tabName) {
      this.tab = tabName;
    },
    pageChanged(index) {
      this.index = index;
    }
  },
  beforeMount() {
    if (this.data == undefined) {
      this.$store.state.loading = true;

      axios.get("takim/oyuncu?player=" + this.slug).then(res => {
        this.$store.state.loading = false;

        this.data = res.data.data;
      });
    }
  },
  computed: {
    getStats() {
      return [
        this.data.stats.all,
        this.data.stats.euroleague,
        this.data.stats.tbl,
        this.data.stats.turkishcup
      ];
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/Player.vue